import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useToast } from "../../../hooks/useToast";
import apiService from "../../../services/apiService";

const DuplicateTowerModal = ({ show, onHide, onConfirm }) => {
  const [newTowerName, setNewTowerName] = useState("");

  const handleConfirm = () => {
    onConfirm(newTowerName);
    setNewTowerName("");
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Duplicate Tower</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Are you sure you want to duplicate this tower?</p>
        <div className="form-group">
          <label>Customer Tower Designation:</label>
          <input
            type="text"
            className="form-control"
            value={newTowerName}
            onChange={(e) => setNewTowerName(e.target.value)}
            placeholder="Enter new tower name"
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary" onClick={onHide}>Cancel</button>
        <button 
          className="btn btn-primary" 
          onClick={handleConfirm}
          disabled={!newTowerName.trim()}
        >
          Duplicate
        </button>
      </Modal.Footer>
    </Modal>
  );
};

const OpportunityModalHeader = ({
  project,
  renderField,
  selectedSerialNumber,
  handleChange,
  towerList,
  formattedTowerData,
}) => {
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);
  const { addToast } = useToast();

  const handleDuplicateTower = async (newTowerName) => {
    try {
      const response = await apiService.post('/tower/duplicate', {
        towerInfo: formattedTowerData,
        newTowerName,
        projectId: project.id
      });

      if (response.status === 201) {
        addToast('Tower duplicated successfully');
        setShowDuplicateModal(false);
        
        if (towerList && Array.isArray(towerList)) {
          const updatedTowerList = [response.data, ...towerList];
          handleChange({ 
            target: { 
              value: response.data.towerInfo.generalTowerDescription.serialNumber 
            } 
          });
        }
      }
    } catch (error) {
      console.error('Error duplicating tower:', error);
      addToast('Error duplicating tower', 'danger');
    }
  };

  const handleTowerSelect = (e) => {
    const newSerialNumber = e.target.value;
    if (newSerialNumber !== selectedSerialNumber) {
      handleChange(e);
    }
  };

  return (
    <Modal.Header className="flex-column align-items-start">
      <DuplicateTowerModal
        show={showDuplicateModal}
        onHide={() => setShowDuplicateModal(false)}
        onConfirm={handleDuplicateTower}
      />
      <Modal.Title>
        [{project.Deal_Name}] - {project.Account_Name?.name}
      </Modal.Title>
      <div className="modal-subtitle">
        {renderField(
          "Customer Tower Designation",
          formattedTowerData?.generalTowerDescription?.customer_tower_designation || project.Customer_Tower_Designation
        )}
        <div className="d-flex align-items-center">
          <div className="me-2">
            <strong>ATS Serial #:</strong>
          </div>
          <select
            className="form-select form-select-sm"
            id="selectTower"
            value={selectedSerialNumber || ""}
            onChange={handleTowerSelect}
            style={{ width: "auto", minWidth: "150px" }}
          >
            {towerList && towerList.length > 0 ? (
              <>
                <option value="">None Selected</option>
                {towerList.map((each) => (
                  <option
                    key={each.id || each._id || each.towerInfo.generalTowerDescription.serialNumber}
                    value={each.towerInfo.generalTowerDescription.serialNumber}
                  >
                    {each.towerInfo.generalTowerDescription.serialNumber}
                  </option>
                ))}
                <option value="create_new">Create New Tower</option>
              </>
            ) : (
              <>
                <option value="">None Selected</option>
                <option value="create_new">Create New Tower</option>
              </>
            )}
          </select>
          {selectedSerialNumber && selectedSerialNumber !== "create_new" && (
            <button
              className="btn btn-sm btn-outline-primary ms-2"
              onClick={() => setShowDuplicateModal(true)}
              title="Duplicate Tower"
            >
              <i className="bi bi-files"></i> Duplicate
            </button>
          )}
        </div>
      </div>
    </Modal.Header>
  );
};

export default OpportunityModalHeader;
